import { Chip, Stack } from "@mui/material";

export const StatusLogo = ({ status,offerStatus }) => {
  return (
    <>
      {status == "hired" && !offerStatus ? (
        <Chip
          style={{
            color: "black",
            backgroundColor: "#e9f9e9",
            borderRadius: "0px",
            marginBottom: "10px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 150"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M46.3572 0.126695C34.3263 2.05255 25.0498 11.1207 23.1663 22.7968C22.6704 25.871 22.957 31.5486 23.7458 34.2861C25.0927 38.9582 27.5304 43.0877 30.9339 46.4625L33.0194 48.5303L30.4686 49.6107C23.4572 52.5797 16.624 57.6124 11.8961 63.2897C4.94879 71.6316 1.05376 81.0863 0.134886 91.8365C-0.68604 101.443 2.25017 109.598 8.67065 115.542L10.4874 117.224L10.8238 114.189C12.749 96.8144 25.6442 82.978 43.0047 79.6583C46.7023 78.9514 53.2546 78.9382 56.852 79.6306C60.7073 80.3726 63.7893 81.3711 66.9095 82.8891C79.4198 88.9757 87.6696 100.571 89.1785 114.189L89.515 117.224L91.3169 115.556C97.7356 109.613 100.706 101.35 99.8582 91.7989C98.8667 80.6338 94.6819 70.7925 87.3804 62.4565C82.4686 56.8486 74.9275 51.5538 68.3163 49.0711L66.9535 48.5595L69.0536 46.4771C72.5058 43.0542 74.9062 38.9692 76.3087 34.1295C76.8784 32.1646 76.9646 31.211 76.9489 27.0485C76.9326 22.6615 76.8606 22.0073 76.1297 19.6144C73.2626 10.2262 66.0352 3.2251 56.7059 0.798967C54.2705 0.165469 48.4689 -0.21119 46.3572 0.126695ZM46.0656 88.02C39.3557 88.8725 31.9131 92.6948 27.5307 97.5388C24.1391 101.288 21.5075 106.117 20.2181 110.959C19.4491 113.845 19.1733 120.06 19.675 123.191C21.6591 135.576 30.4733 145.123 42.9175 148.366C46.644 149.338 53.3779 149.332 57.1435 148.353C69.4451 145.158 78.3578 135.485 80.3274 123.191C80.8291 120.06 80.5533 113.845 79.7842 110.959C77.4002 102.008 71.459 94.7801 63.2654 90.8622C57.6469 88.1757 52.0815 87.2559 46.0656 88.02ZM60.4074 108.956C62.2396 110.074 62.9765 112.308 62.1582 114.266C61.6449 115.495 50.5781 127.464 49.3846 128.082C48.3485 128.617 46.4099 128.621 45.3951 128.089C44.9622 127.862 43.0822 126.124 41.2176 124.226C38.7534 121.719 37.7698 120.511 37.6182 119.806C37.006 116.96 38.9615 114.508 41.8432 114.508C43.3714 114.508 43.9754 114.827 45.7934 116.592L47.2702 118.026L51.3323 113.603C53.5665 111.171 55.7879 109.007 56.2689 108.795C57.5452 108.231 59.3331 108.301 60.4074 108.956Z"
                  fill="#25C027"
                />
              </svg>
              Hired
            </Stack>
          }
        />
      ) : null}
      {status == "rejected" ? (
        <Chip
          style={{
            marginBottom: "10px",
            color: "black",
            backgroundColor: "#fbeae9",
            borderRadius: "0px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5886 8.5886L0 17.1772L16.4096 33.5885L32.8195 50L16.4096 66.4115L0 82.8228L8.5886 91.4114L17.1772 100L33.5885 83.5904L50 67.1805L66.4115 83.5904L82.8228 100L91.4114 91.4114L100 82.8228L83.5904 66.4115L67.1805 50L83.5904 33.5885L100 17.1772L91.4114 8.5886L82.8228 0L66.4115 16.4096L50 32.8195L33.5885 16.4096L17.1772 0L8.5886 8.5886Z"
                  fill="#D93025"
                />
              </svg>
              Rejected
            </Stack>
          }
        />
      ) : null}
      {status == "pending" ? (
        <Chip
          style={{
            color: "black",
            backgroundColor: "#fef2d9",
            borderRadius: "0px",
            marginBottom: "10px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 154"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M52.3163 35.6856C28.963 55.3129 9.59231 71.7173 9.27019 72.1403C8.47788 73.1803 8.50625 75.1313 9.33029 76.3089C9.7024 76.8407 15.7683 80.0713 22.8091 83.4882C29.8505 86.9046 35.5495 89.9456 35.474 90.2454C35.3986 90.5453 27.3861 103.901 17.6683 119.926C6.07692 139.039 0 149.504 0 150.349C0 152.095 1.97837 154 3.79135 154C4.87452 154 6.31346 153.086 9.70289 150.245C56.1591 111.311 89.8356 82.9069 90.4942 82.1037C91.5087 80.8664 91.5798 78.9919 90.6615 77.6795C90.2851 77.1415 84.2212 73.9032 77.1865 70.4824C70.1514 67.0622 64.4558 64.0274 64.5293 63.7392C64.6034 63.4504 72.6144 50.0986 82.3317 34.0677C93.8351 15.0915 100 4.47466 100 3.64162C100 1.90527 98.0163 0 96.2082 0C95.0144 0 87.7202 5.93044 52.3163 35.6856Z"
                  fill="#F9AB00"
                />
              </svg>
              Yet to be review
            </Stack>
          }
        />
      ) : null}{" "}
      {status == "accepted" ? (
        <Chip
          style={{
            color: "black",
            backgroundColor: " #fef2d9",
            borderRadius: "0px",
            marginBottom: "10px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M61.9634 22.9635C48.3341 35.5936 36.8684 46.2276 36.4841 46.5948L35.7853 47.2622L25.0645 35.8266C19.1681 29.5372 14.2572 24.4199 14.1515 24.4553C14.0458 24.4904 10.8183 27.4553 6.9796 31.0436L0 37.5679L0.614347 38.2761C0.952199 38.6657 8.7861 47.042 18.0228 56.8906L34.8169 74.7967L35.9022 73.7446C36.4991 73.1662 50.8366 59.8809 67.7634 44.2221C84.6902 28.5631 98.868 15.4336 99.2696 15.0456L100 14.3399L94.5045 8.38358C91.482 5.10756 88.4994 1.88116 87.8764 1.21361L86.7439 0L61.9634 22.9635Z"
                  fill="#F9AB00"
                />
              </svg>
              Shortlisted
            </Stack>
          }
        />
      ) : null}
      {/* {status == "invited" || method=="invite" ? (
        <Chip
          style={{
            color: "black",
            backgroundColor: "#fbeae9",
            borderRadius: "0px",
            marginBottom: "10px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M94.3765 0.938263C93.3766 1.46008 82.5307 7.1048 70.2743 13.4821C58.0178 19.8594 37.5253 30.5224 24.7352 37.1779C11.9453 43.8335 1.26806 49.4737 1.00827 49.7122C0.423209 50.249 0 51.2079 0 51.9973C0 52.771 0.657001 54.0478 1.25653 54.4393C1.93992 54.8855 27.9723 63.717 28.2692 63.6035C28.407 63.5507 32.153 60.4097 36.5933 56.6233C41.0337 52.8368 53.1993 42.4774 63.628 33.6021C74.0568 24.7269 82.805 17.2805 83.0687 17.0544L83.548 16.6432L83.0687 17.2345C82.805 17.5598 73.2211 29.0717 61.771 42.8164C50.3209 56.5612 40.9303 67.8657 40.9031 67.9375C40.8658 68.0367 82.8433 82.4368 84.9744 83.0558C85.9635 83.3431 87.6996 82.4841 88.2418 81.4391C88.6337 80.6837 100.154 3.24602 99.9984 2.41645C99.8409 1.58026 99.0228 0.600125 98.1942 0.25517C97.0782 -0.209381 96.3129 -0.0724503 94.3765 0.938263ZM36.5544 83.2677C36.5544 94.1779 36.533 93.9531 37.6512 94.8294C38.9398 95.8396 40.6821 95.7457 41.7713 94.6076C42.5598 93.7837 53.4167 79.0564 53.3123 78.9521C53.2341 78.8744 36.7795 73.2268 36.6308 73.2268C36.5888 73.2268 36.5544 77.7451 36.5544 83.2677Z"
                  fill="#25C027"
                />
              </svg>
              Invited
            </Stack>
          }
        />
      ) : null}
      {status == "offerAccepted" ? (
        <Chip
          style={{
            color: "black",
            backgroundColor: "#e9f9e9",
            borderRadius: "0px",
            marginBottom: "10px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 128"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.76848 0.375582C1.60183 0.896414 0.506469 2.18272 0.235875 3.34976C-0.078978 4.70657 -0.0784482 117.221 0.236405 118.578C0.531646 119.85 1.91748 121.321 3.1586 121.678C3.7679 121.854 11.5038 121.921 25.3611 121.87L46.6282 121.792L45.077 119.721C42.312 116.028 40.2713 111.566 39.1756 106.817C38.4174 103.531 38.2348 97.3796 38.7943 93.9747C41.1194 79.8291 52.0271 69.0241 66.9386 66.0963C70.2968 65.4369 76.1627 65.4814 79.4941 66.1918C84.3202 67.221 88.8098 69.2823 92.7298 72.2692C93.7518 73.0479 94.6505 73.6851 94.7268 73.6851C94.8032 73.6851 94.8657 64.501 94.8657 53.2759V32.8667H80.2128H65.56L64.3928 32.2704C63.7511 31.9422 62.9804 31.3374 62.6804 30.9257C62.1469 30.1942 62.1332 29.8427 62.0621 15.0887L61.9895 0L32.7765 0.010337C8.95953 0.0188187 3.41674 0.0864077 2.76848 0.375582ZM70.4831 13.5178V24.385H81.4142H92.3455L81.4818 13.5178C75.5067 7.5408 70.5878 2.65054 70.5507 2.65054C70.5136 2.65054 70.4831 7.5408 70.4831 13.5178ZM68.2715 72.235C59.3061 73.9321 51.2977 79.8553 47.4615 87.6264C45.4891 91.6221 44.6887 94.9915 44.6975 99.2628C44.7105 105.539 46.6709 111.23 50.5485 116.248C54.5698 121.451 59.5616 124.874 65.4479 126.464C67.3425 126.976 68.3531 127.073 71.8083 127.072C74.7297 127.071 76.4139 126.946 77.6389 126.637C87.3535 124.193 94.9492 117.781 98.4261 109.089C99.7056 105.891 100.014 104.07 99.9996 99.7929C99.9884 96.3722 99.8901 95.4553 99.2948 93.2257C98.5528 90.4463 96.8788 86.6627 95.2972 84.1897C93.9209 82.038 90.1543 78.2165 87.8189 76.6018C85.2258 74.8089 81.9575 73.2968 79.2007 72.6145C76.2324 71.8798 71.0906 71.7014 68.2715 72.235ZM84.2646 88.9384C86.397 90.0151 87.2676 92.6802 86.1081 94.582C85.0793 96.2698 73.9142 109.484 73.0968 109.981C71.7693 110.788 70.6313 110.885 69.3562 110.3C68.0981 109.722 60.3477 103.181 59.8754 102.299C59.4784 101.557 59.4884 99.6066 59.8931 98.8228C60.76 97.144 62.193 96.2139 63.9104 96.216C65.2168 96.2176 65.7397 96.5137 68.4461 98.7844L70.4034 100.426L74.7501 95.2091C77.1406 92.3396 79.3838 89.7206 79.7353 89.389C80.8807 88.3081 82.6649 88.1306 84.2646 88.9384Z"
                  fill="#25C027"
                />
              </svg>
              Offer Accepted
            </Stack>
          }
        />
      ) : null}
      {status == "offerRejected" ? (
        <Chip
          style={{
            color: "black",
            backgroundColor: "#fbeae9",
            borderRadius: "0px",
            marginBottom: "10px",
          }}
          label={
            <Stack alignItems={"center"} direction gap={1}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M30.2295 0.278672C28.577 0.691875 27.34 1.39748 26.0939 2.63787C24.8106 3.91553 24.0348 5.32242 23.6774 7.02053C23.5262 7.7381 23.4585 13.2643 23.4585 24.8736V41.6872L25.418 41.6086C29.5546 41.4425 34.3245 42.296 38.4605 43.9421C42.5629 45.5749 46.3022 48.0855 49.5967 51.4192L51.4965 53.3418H67.7093C83.5711 53.3418 83.939 53.3505 84.6968 53.7366C85.5676 54.1806 86.2618 55.3104 86.2618 56.2835C86.2618 57.2566 85.5676 58.3864 84.6968 58.8304C83.9416 59.2153 83.5669 59.2251 69.6097 59.2251H55.297L56.0365 60.9411C57.2997 63.8716 58.1789 67.0456 58.5118 69.8747L58.6431 70.9917H71.2828C83.5632 70.9917 83.9443 71.0029 84.6968 71.3865C85.5676 71.8305 86.2618 72.9603 86.2618 73.9334C86.2618 74.9065 85.5676 76.0362 84.6968 76.4802C83.9443 76.8638 83.5632 76.875 71.2932 76.875H58.6643L58.4119 78.6563C57.2883 86.5893 52.5777 94.68 46.3427 99.3862L44.9887 100.408H68.4614C84.9833 100.408 92.242 100.343 92.9741 100.189C96.3046 99.4884 99.086 96.7097 99.7822 93.3876C99.9368 92.6499 100 82.6524 100 58.9214V25.4943H88.3983H76.7966L76.0137 25.0546C75.5542 24.7965 75.0769 24.3137 74.8585 23.8858C74.5054 23.1941 74.4862 22.5595 74.4862 11.5783V0L52.8485 0.0166693C36.2294 0.0294165 30.9832 0.0902105 30.2295 0.278672ZM80.374 10.688V19.611H89.3521H98.3302L89.402 10.688C84.4915 5.78033 80.4513 1.76499 80.4238 1.76499C80.3964 1.76499 80.374 5.78033 80.374 10.688ZM84.6968 36.0867C85.5676 36.5307 86.2618 37.6605 86.2618 38.6336C86.2618 39.6067 85.5676 40.7365 84.6968 41.1805C83.9341 41.5692 83.5844 41.5753 61.7147 41.5753H39.5071L38.7242 41.1356C36.7491 40.0264 36.7291 37.342 38.687 36.1577L39.4537 35.6939L61.6881 35.6929C83.5856 35.692 83.9339 35.6978 84.6968 36.0867ZM23.6548 47.5788C17.3388 48.3557 12.0493 50.933 7.65763 55.3735C3.75735 59.3171 1.5086 63.5264 0.361658 69.0306C-0.120553 71.3437 -0.120553 76.523 0.361658 78.8361C1.50978 84.3462 3.76481 88.5643 7.65763 92.4842C11.6103 96.4642 15.93 98.7959 21.4959 99.9542C23.7833 100.43 28.9628 100.43 31.3562 99.9532C36.6525 98.8989 41.0407 96.5505 44.9765 92.6638C48.9294 88.7604 51.2835 84.4005 52.4432 78.8361C52.9254 76.5232 52.9254 71.3437 52.4432 69.0306C51.6892 65.4124 50.2914 62.0473 48.2888 59.029C47.0531 57.1668 43.219 53.3222 41.4001 52.1214C38.2365 50.0331 34.8257 48.5991 31.4622 47.9437C29.8806 47.6354 25.0355 47.4089 23.6548 47.5788ZM18.8072 62.4804C19.1526 62.6527 21.0027 64.3507 22.9188 66.2533L26.4024 69.7129L29.8861 66.2533C31.8019 64.3507 33.6523 62.6527 33.9977 62.4804C36.3942 61.2841 39.0614 63.9492 37.8642 66.3439C37.6917 66.6891 35.9925 68.538 34.0884 70.4524L30.6262 73.9334L34.0884 77.4143C35.9925 79.3287 37.6917 81.1777 37.8642 81.5228C39.0614 83.9175 36.3942 86.5826 33.9977 85.3864C33.6523 85.214 31.8019 83.5161 29.8861 81.6134L26.4024 78.1538L22.9188 81.6134C21.0027 83.5161 19.1526 85.214 18.8072 85.3864C16.4106 86.5826 13.7435 83.9175 14.9406 81.5228C15.1132 81.1777 16.8124 79.3287 18.7165 77.4143L22.1787 73.9334L18.7165 70.4524C16.8124 68.538 15.1132 66.6891 14.9406 66.3439C13.7431 63.9484 16.4099 61.2837 18.8072 62.4804Z"
                  fill="#D93025"
                />
              </svg>
              Offer Rejected
            </Stack>
          }
        />
      ) : null} */}
    </>
  );
};
